module.exports = __webpack_public_path__ + "media/elin_home.acdac9ed.mp4";